import React from "react";
import "./App.css";
import "./ujms/cjms.css";
import "./ujms/court-home.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Login from "./pages/Login";
import { Outlet, useOutletContext } from "react-router-dom";

const Legacy = () => { const ctx = useOutletContext(); return <div className="ent-legacy" data-testid="ent-legacy"><Outlet context={ctx} /></div>; };
const OfficerIncidentRedirect = () => { const { id } = useParams(); return <Navigate to={`/officer/incident/${id}`} replace />; };
const OfficerReportRedirect = () => { const { id } = useParams(); return <Navigate to={`/officer/report/${id}`} replace />; };
const ClassicRedirect = () => { const { id } = useParams(); return <Navigate to={`/cases/${id}`} replace />; };
import EnterpriseShell, { RoleHome } from "./ujms/enterprise/EnterpriseShell";
import CaseWorkspaceV2 from "./ujms/enterprise/CaseWorkspaceV2";
import OfficerEdition from "./ujms/enterprise/officer/OfficerEdition";
import WorkspaceHome from "./ujms/enterprise/workspace/WorkspaceHome";
import CourtCalculators from "./ujms/enterprise/workspace/Calculators";
import CourtDirectory from "./ujms/enterprise/workspace/CourtShortcuts";
import CaseIntegrity from "./ujms/enterprise/CaseIntegrity";
import SearchHub, { LegacySearchRedirect } from "./ujms/pages/SearchHub";
import AttorneyEdition from "./ujms/enterprise/attorney/AttorneyEdition";
import DocumentWorkspace from "./ujms/enterprise/DocumentWorkspace";
import ClerkEdition from "./ujms/enterprise/clerk/ClerkEdition";
import AppellateEdition from "./ujms/enterprise/appellate/AppellateEdition";
import AppellateCaseWorkspace from "./ujms/enterprise/appellate/AppellateCaseWorkspace";
import ChriEdition from "./ujms/enterprise/chri/ChriEdition";
import FoidPortal from "./ujms/FoidPortal";
import PublicBackgroundCheck from "./ujms/PublicBackgroundCheck";import ClerkSessionWorkspace from "./ujms/enterprise/clerk/ClerkSessionWorkspace";
import JudgeEdition from "./ujms/enterprise/judge/JudgeEdition";
import JudgeSession from "./ujms/enterprise/judge/JudgeSession";
import { RequirePerm } from "./ujms/enterprise/RequirePerm";
import TrafficDashboard from "./ujms/enterprise/traffic/TrafficDashboard";
import TimeStandards from "./ujms/enterprise/standards/TimeStandards";
import IntakeWizard from "./ujms/pages/IntakeWizard";
import FilingQueue from "./ujms/pages/FilingQueue";
import DocketQueue from "./ujms/pages/DocketQueue";
import CourtCalendar from "./ujms/pages/CourtCalendar";
import CaseSearch from "./ujms/pages/CaseSearch";
import RecordsPersons from "./ujms/pages/RecordsPersons";
import UjmsTasks from "./ujms/pages/UjmsTasks";
import UjmsOrg from "./ujms/pages/UjmsOrg";
import AdminEdition from "./ujms/enterprise/admin/AdminEdition";
import IntegrationHub from "./ujms/pages/IntegrationHub";
import Reports from "./ujms/pages/Reports";
import GlobalSearch from "./ujms/pages/GlobalSearch";
import CourtRules from "./ujms/pages/CourtRules";
import LECaseView from "./ujms/pages/LECaseView";
import ReportWriting from "./ujms/pages/ReportWriting";
import ReportLibrary from "./ujms/pages/ReportLibrary";
import CriminalPipeline from "./ujms/pages/CriminalPipeline";
import PretrialWorkspace from "./ujms/pages/PretrialWorkspace";
import ProbationWorkspace from "./ujms/pages/ProbationWorkspace";
import IspBackgroundOrder from "./ujms/pages/IspBackgroundOrder";
import PublicPortal, { PublicCaseView } from "./ujms/pages/PublicPortal";
import PublicCustodyLocator from "./ujms/PublicCustodyLocator";
import FinanceDashboard from "./ujms/pages/FinanceDashboard";
import CourtServices from "./ujms/pages/CourtServices";
import WarrantCenter from "./ujms/enterprise/warrants/WarrantCenter";
import MotionsQueue from "./ujms/pages/MotionsQueue";
import DailyDigest from "./ujms/pages/DailyDigest";
import Departments from "./ujms/pages/Departments";
import SalesKit from "./ujms/pages/SalesKit";
import Marketing from "./pages/Marketing";
import Tills from "./ujms/pages/Tills";
import EFile from "./ujms/pages/EFile";
import CertifiedLog from "./ujms/pages/CertifiedLog";
import FtaReport from "./ujms/pages/FtaReport";
import ProfilePage from "./ujms/enterprise/profile/ProfilePage";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const AppRoutes = () => {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/start" replace /> : <Login />} />
      <Route path="/foid" element={<FoidPortal />} />
      <Route path="/background-check" element={<PublicBackgroundCheck />} />
      <Route path="/" element={user ? <Navigate to="/start" replace /> : <Marketing />} />
      <Route path="/home" element={<Marketing />} />
      <Route path="/portal" element={<PublicPortal />} />
      <Route path="/portal/case/:caseNumber" element={<PublicCaseView />} />
      <Route path="/custody-locator" element={<PublicCustodyLocator />} />
      <Route element={<Protected><EnterpriseShell /></Protected>}>
        <Route path="/start" element={<RoleHome />} />
        <Route path="/dashboard" element={<RequirePerm perms={["case.view", "task.view"]} label="Court Home"><WorkspaceHome /></RequirePerm>} />
        <Route path="/directory" element={<RequirePerm perms={["case.view", "task.view"]} label="Departments & tools"><CourtDirectory /></RequirePerm>} />
        <Route path="/search" element={<SearchHub />} />
        <Route path="/case-integrity" element={<RequirePerm perms={["administration.manage", "case.assign", "order.sign"]} label="Case integrity"><CaseIntegrity /></RequirePerm>} />
        <Route path="/tools" element={<RequirePerm perms={["case.view"]} label="Court calculators"><CourtCalculators /></RequirePerm>} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/cases/:caseId" element={<CaseWorkspaceV2 />} />
        <Route path="/clerk" element={<RequirePerm perms={["clerk.session.view"]} label="Clerk operations"><ClerkEdition /></RequirePerm>} />
        <Route path="/clerk/session/:sessionId" element={<RequirePerm perms={["clerk.session.view"]} label="Clerk operations"><ClerkSessionWorkspace /></RequirePerm>} />
        <Route path="/clerk/session/:sessionId/case/:caseId" element={<RequirePerm perms={["clerk.session.view"]} label="Clerk operations"><ClerkSessionWorkspace /></RequirePerm>} />
        <Route path="/clerk/classic/*" element={<Navigate to="/clerk" replace />} />
        <Route path="/judge" element={<RequirePerm perms={["judge.view.case"]} label="Judicial workspace"><JudgeEdition /></RequirePerm>} />
        <Route path="/judge/session/:sessionId" element={<RequirePerm perms={["judge.view.case"]} label="Judicial workspace"><JudgeSession /></RequirePerm>} />
        <Route path="/judge/session/:sessionId/case/:caseId" element={<RequirePerm perms={["judge.view.case"]} label="Judicial workspace"><JudgeSession /></RequirePerm>} />
        <Route path="/appellate" element={<RequirePerm perms={["appellate.manage"]} label="Appellate Court"><AppellateEdition /></RequirePerm>} />
        <Route path="/appellate/cases/:id" element={<RequirePerm perms={["appellate.manage"]} label="Appellate Court"><AppellateCaseWorkspace /></RequirePerm>} />
        <Route path="/chri" element={<RequirePerm perms={["chri.manage", "foid.review"]} label="ISP CHRI"><ChriEdition /></RequirePerm>} />
        <Route path="/admin" element={<RequirePerm perms={["administration.manage", "audit.view"]} label="Administration"><AdminEdition /></RequirePerm>} />
        <Route path="/officer" element={<RequirePerm perms={["criminal.refer", "custody.manage", "citation.issue"]} label="Law enforcement"><OfficerEdition /></RequirePerm>} />
        <Route path="/officer/report/:id" element={<RequirePerm perms={["criminal.refer"]} label="Law enforcement"><div className="ent-legacy" data-testid="ent-officer"><ReportWriting /></div></RequirePerm>} />
        <Route path="/officer/incident/:id" element={<RequirePerm perms={["criminal.refer", "case.view"]} label="Law enforcement"><div className="ent-legacy" data-testid="ent-officer"><LECaseView /></div></RequirePerm>} />
        <Route path="/traffic" element={<RequirePerm perms={["audit.view", "finance.disburse", "administration.manage"]} label="Traffic Dashboard"><TrafficDashboard /></RequirePerm>} />
        <Route path="/time-standards" element={<RequirePerm perms={["case.view"]} label="Time Standards"><TimeStandards /></RequirePerm>} />
        <Route path="/judge/classic/*" element={<Navigate to="/judge" replace />} />
        <Route path="/attorney/*" element={<AttorneyEdition />} />
        <Route path="/documents/:documentId/view" element={<DocumentWorkspace />} />
        <Route path="/ujms" element={<Legacy />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="clerk" element={<Navigate to="/clerk" replace />} />
        <Route path="intake" element={<IntakeWizard />} />
        <Route path="filings" element={<FilingQueue />} />
        <Route path="docket" element={<DocketQueue />} />
        <Route path="calendar" element={<CourtCalendar />} />
        <Route path="court-call" element={<Navigate to="/clerk" replace />} />
        <Route path="clerk-session" element={<Navigate to="/clerk" replace />} />
        <Route path="le-records" element={<Navigate to="/officer?tab=incidents" replace />} />
        <Route path="le-records/:id" element={<OfficerIncidentRedirect />} />
        <Route path="report-writing/:id" element={<OfficerReportRedirect />} />
        <Route path="report-library" element={<ReportLibrary />} />
        <Route path="courtroom" element={<Navigate to="/judge" replace />} />
        <Route path="judge" element={<Navigate to="/judge" replace />} />
        <Route path="bench" element={<Navigate to="/judge" replace />} />
        <Route path="reports/fta" element={<FtaReport />} />
        <Route path="motions" element={<MotionsQueue />} />
        <Route path="digest" element={<DailyDigest />} />
        <Route path="criminal" element={<CriminalPipeline />} />
        <Route path="prosecutor" element={<Navigate to="/attorney?view=charging" replace />} />
        <Route path="defense" element={<Navigate to="/attorney?view=clients" replace />} />
        <Route path="pretrial" element={<PretrialWorkspace />} />
        <Route path="probation" element={<ProbationWorkspace />} />
        <Route path="finance" element={<FinanceDashboard />} />
        <Route path="services" element={<CourtServices />} />
        <Route path="isp-background" element={<IspBackgroundOrder />} />        <Route path="sheriff" element={<Navigate to="/officer?tab=custody" replace />} />
        <Route path="warrants" element={<WarrantCenter />} />
        <Route path="cases" element={<LegacySearchRedirect />} />
        <Route path="cases/:id" element={<CaseWorkspaceV2 />} />
        <Route path="cases/:id/classic" element={<ClassicRedirect />} />
        <Route path="records" element={<RecordsPersons />} />
        <Route path="tasks" element={<UjmsTasks />} />
        <Route path="org" element={<UjmsOrg />} />
        <Route path="admin" element={<Navigate to="/admin" replace />} />
        <Route path="integrations" element={<IntegrationHub />} />
        <Route path="reports" element={<Reports />} />
        <Route path="search" element={<LegacySearchRedirect global />} />
        <Route path="rules" element={<CourtRules />} />
        <Route path="forms" element={<Navigate to="/dashboard" replace />} />
        <Route path="arrests" element={<Navigate to="/officer?tab=arrests" replace />} />
        <Route path="departments" element={<Departments />} />
        <Route path="sales-kit" element={<SalesKit />} />
        <Route path="tills" element={<Tills />} />
        <Route path="efile" element={<EFile />} />
        <Route path="citations" element={<Navigate to="/officer?tab=citations" replace />} />
        <Route path="certified-log" element={<CertifiedLog />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
